import { isExtendable, isUpright } from '../../services/products';
import { applicationSettings } from '../../settings/application';
import { getDependencyDiff } from '../tac/range/boaxel/dependentItems';
import updateItem from '../tac/tacReducer/updateItem';
import addItem from '../tac/tacReducer/addItem';

function ignoredAutoUpdate(meta) {
  return (
    ['JONAXEL', 'AURDAL'].includes(applicationSettings.applicationName) &&
    meta?.automatedUpdate
  );
}

function adjustableItem(item, meta) {
  if (
    ['JONAXEL', 'AURDAL'].includes(applicationSettings.applicationName) &&
    isExtendable(item.id)
  ) {
    return item;
  }
  if (applicationSettings.applicationName === 'BOAXEL') {
    if (!isUpright(item.id) || meta.origin === 'dialog') {
      return false;
    }
    const updatedTac = item.itemid
      ? updateItem(meta.tac, item)
      : addItem(meta.tac, item);

    const diff = getDependencyDiff(updatedTac, { triggerItem: item });
    return [...diff.added, ...diff.updated].find(isExtendable);
  }
}

export function extendableConfItem(item, meta) {
  return !ignoredAutoUpdate(meta) && adjustableItem(item, meta);
}
